import { HttpClient, parseJSONApiResponse } from '@opallabs/api'
import { loadJsonApiEntities } from '../loadJsonApiEntities'
import loadMessage from '../loadMessage'

const postMessage = ({ annotationId, message, creatorGuid }) => {
  const messageAttributes = {
    data: {
      type: 'message',
      attributes: {
        message,
      },
      creator_guid: creatorGuid,
    },
    params: {
      include: 'annotation',
    },
  }

  return HttpClient().post(`/messages/v1/${annotationId}`, messageAttributes)
}

const createMessage = (options) => (dispatch) =>
  postMessage(options)
    .then((response) => {
      const body = response.data
      if (body.data) {
        dispatch(loadJsonApiEntities(body))
        dispatch(
          loadMessage(options.annotationId, parseJSONApiResponse(response.data))
        )
      }

      return body.data
    })
    .catch((err) => {
      console.log(err)
      throw err
    })

export default createMessage
